var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 32 32",
    width: 25,
    height: 25,
    viewBox: "0 0 32 32",
    id: "star",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8,13c-0.2-0.7-0.9-1.2-1.6-1.3l-6.5-1l-2.9-6.2c-0.5-1-1.7-1.4-2.7-1c-0.4,0.2-0.8,0.5-1,1l-2.9,6.1l-6.5,1 c-1.1,0.2-1.8,1.2-1.7,2.3c0.1,0.4,0.2,0.8,0.5,1.1l4.8,4.9l-1.1,6.9c-0.2,1.1,0.6,2.1,1.7,2.3c0.4,0.1,0.9,0,1.3-0.2l5.8-3.2 l5.8,3.2c1,0.5,2.2,0.2,2.7-0.8c0.2-0.4,0.3-0.8,0.2-1.3l-1.1-6.9l4.8-4.9C28.9,14.5,29,13.7,28.8,13z M21.8,18.9 c-0.2,0.2-0.3,0.5-0.3,0.9l1.2,7.4l-6.2-3.5c-0.3-0.2-0.7-0.2-1,0l-6.2,3.4l1.2-7.4c0-0.3-0.1-0.6-0.3-0.9l-5.1-5.3l7.1-1.1 c0.3,0,0.6-0.3,0.8-0.6L16,5.3l0,0l3.1,6.7c0.1,0.3,0.4,0.5,0.8,0.6l7.1,1.1L21.8,18.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.cdbbc528bcb6aab3026d43d419c9b9d7.svg";
export { ForwardRef as ReactComponent };